import { render, staticRenderFns } from "./ProviderOrderListDataTable.vue?vue&type=template&id=1013cc30&"
import script from "./ProviderOrderListDataTable.vue?vue&type=script&lang=js&"
export * from "./ProviderOrderListDataTable.vue?vue&type=script&lang=js&"
import style0 from "./ProviderOrderListDataTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports